import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_idprint } from "../../idprint/shared/data.service";
import { wsPrintSchoolOptionsInfoParm } from "../../idprint/shared/wsPrintSchoolOptionsInfoParm";
import { ConfirmationService } from "primeng/api";
import { wsImageStagingQueueFilterListRequest } from "../shared/wsImageStagingQueueFilterListInfo";
import { DataService_photomaint } from "../shared/data.service";

@Component({
	selector: "app-photo-transfer-dialog",
	templateUrl: "./photo-transfer-dialog.component.html",
	styleUrls: ["./photo-transfer-dialog.component.css"],
})
export class PhotoTransferDialogComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private printService: DataService_idprint,
		private photoService: DataService_photomaint,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		console.log(this.dialogConfig.data);

		this.lstQueue = this.dialogConfig.data.lstQueue;
		this.CheckQueue();

		this.intTransferCount = this.dialogConfig.data.intTransferCount;
		this.strWork = this.dialogConfig.data.strWork;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		this.loadData();
		this.loadFilterLists();
	}

	////////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////////

	lstQueue: any = [];

	SchoolID: number = 0;
	intTransferCount: number = 0;
	strWork: string = "";

	TransferOption: string = "N/A";
	lstTransferOption: string[] = ["TransferOnly", "AddToQ", "SkipToPrint"];

	lstPrinter: any = [];

	HasStudent: boolean = false;
	HasStaff: boolean = false;

	Student_IDPrinterID: number = -1;
	Student_IDCardTemplateID: string = "";
	lstStudentTemplates: any = [];

	Staff_IDPrinterID: number = -1;
	Staff_IDCardTemplateID: string = "";
	lstStaffTemplates: any = [];

	Student_SortID: number = 1;
	lstStudentSortBy: any = [
		{
			ID: 1,
			Desc: "Name",
		},
		{
			ID: 2,
			Desc: "Academy",
		},
		{
			ID: 3,
			Desc: "Grade",
		},
		{
			ID: 4,
			Desc: "Homeroom",
		},
	];

	Student_AcademyID: number = -1;
	lstAcademy: any = [];

	Student_GradeLevelID: number = -1;
	lstGradeLevel: any = [];

	Student_HomeroomID: number = -1;
	lstHomeroom: any = [];

	Staff_SortID: number = 1;
	lstStaffSortBy: any = [
		{
			ID: 1,
			Desc: "Name",
		},
	];

	errorMessage: string = "";

	LoadingData: boolean = false;
	CheckingQ: boolean = false;
	Processing: boolean = false;
	LoadingFilters: boolean = false;

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////////////////////

	loadData() {
		this.LoadingData = true;

		var parms: wsPrintSchoolOptionsInfoParm = {
			SchoolID: this.SchoolID,
		};

		var result = this.printService.IDPrintSchoolOptionsGet(parms);
		result.subscribe(
			(response: any) => {
				this.LoadingData = false;

				this.lstPrinter = response.Printers;
				this.lstPrinter.unshift({
					IDPrinterID: -1,
					PrinterName: "- Select a Printer -",
					ScanStation: "",
				});

				this.Student_IDPrinterID = this.lstPrinter[0].IDPrinterID;
				this.Staff_IDPrinterID = this.lstPrinter[0].IDPrinterID;

				this.lstStudentTemplates = response.StudentTemplates;
				this.lstStudentTemplates.unshift({
					CardName: "- Select a Card Template -",
					IDCardTemplateID: "",
				});
				this.Student_IDCardTemplateID = this.lstStudentTemplates[0].IDCardTemplateID;

				this.lstStaffTemplates = response.StaffTemplates;
				this.lstStaffTemplates.unshift({
					CardName: "- Select a Card Template -",
					IDCardTemplateID: "",
				});
				this.Staff_IDCardTemplateID = this.lstStaffTemplates[0].IDCardTemplateID;
			},
			(error) => {
				this.LoadingData = false;
			}
		);
	}

	loadFilterLists() {
		this.LoadingFilters = true;

		var lstQIDs: string[] = [];

		for (var z = 0; z < this.lstQueue.length; z++) {
			var next = this.lstQueue[z];

			if (next.IsChecked == true && next.PersonID > 0) {
				if (next.IsStudent == true) {
					lstQIDs = [...lstQIDs, next.ImageStagingQueueID];
				}
			}
		}

		if (lstQIDs.length > 0) {
			var parms: wsImageStagingQueueFilterListRequest = {
				lstImageStagingQueueID: lstQIDs,
			};

			var result = this.photoService.ImageStagingQueueFilterListSelect(parms);
			result.subscribe(
				(response: any) => {
					this.LoadingFilters = false;

					//
					// Academy
					//
					// Create AcademyInfo, then make a Dictionary(Map) using AcademyID, then use Unique Values as Array
					this.lstAcademy = Array.from(
						new Map(response.map((item) => [item.AcademyID, { AcademyID: item.AcademyID, AcademyDesc: item.AcademyDesc }])).values()
					);

					this.lstAcademy.sort((a: any, b: any) => {
						if (a.AcademyDesc < b.AcademyDesc) {
							return -1;
						} else if (a.AcademyDesc > b.AcademyDesc) {
							return 1;
						} else {
							return 0;
						}
					});

					this.lstAcademy.unshift({
						AcademyID: -1,
						AcademyDesc: "All",
					});

					this.Student_AcademyID = this.lstAcademy[0].AcademyID;

					//
					// Grade Level
					//
					this.lstGradeLevel = Array.from(
						new Map(response.map((item) => [item.GradeLevelID, { GradeLevelID: item.GradeLevelID, GradeLevelDesc: item.GradeLevelDesc }])).values()
					);

					this.lstGradeLevel.sort((a: any, b: any) => {
						if (a.GradeLevelDesc < b.GradeLevelDesc) {
							return -1;
						} else if (a.GradeLevelDesc > b.GradeLevelDesc) {
							return 1;
						} else {
							return 0;
						}
					});

					this.lstGradeLevel.unshift({
						GradeLevelID: -1,
						GradeLevelDesc: "All",
					});

					this.Student_GradeLevelID = this.lstGradeLevel[0].GradeLevelID;

					//
					// Homeroom
					//
					this.lstHomeroom = Array.from(
						new Map(response.map((item) => [item.HomeroomID, { HomeroomID: item.HomeroomID, HomeroomDesc: item.HomeroomDesc }])).values()
					);

					this.lstHomeroom.sort((a: any, b: any) => {
						if (a.HomeroomDesc < b.HomeroomDesc) {
							return -1;
						} else if (a.HomeroomDesc > b.HomeroomDesc) {
							return 1;
						} else {
							return 0;
						}
					});
					this.lstHomeroom.unshift({
						HomeroomID: -1,
						HomeroomDesc: "All",
					});
					this.Student_HomeroomID = this.lstHomeroom[0].HomeroomID;
				},
				(error) => {
					this.LoadingFilters = false;
				}
			);
		} else {
			this.LoadingFilters = false;
		}
	}

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////////////

	onTransfer() {
		this.errorMessage = "";

		//Check Transfer Option
		var found = false;
		for (var z = 0; z < this.lstTransferOption.length; z++) {
			var next = this.lstTransferOption[z];

			if (this.TransferOption == next) {
				found = true;
				break;
			}
		}

		if (found == false) {
			this.errorMessage = "Select transfer option";
			return;
		}

		var CheckBlank = true;
		var AllowBlank = true;
		var AnyBlank = false;

		//Transfer only, ignore Queue Options
		if (this.TransferOption == "TransferOnly") {
			CheckBlank = false;
		}
		//Skip to print, MUST have printer and card selected
		if (this.TransferOption == "SkipToPrint") {
			AllowBlank = false;
		}

		//If Send to Q or Skip to print, check if the Q options were picked
		if (CheckBlank == true) {
			if (this.HasStudent == true) {
				if (this.Student_IDPrinterID <= 0 || this.Student_IDCardTemplateID == "") {
					AnyBlank = true;
				}
			}

			if (this.HasStaff == true) {
				if (this.Staff_IDPrinterID <= 0 || this.Staff_IDCardTemplateID == "") {
					AnyBlank = true;
				}
			}

			//Options left blank, show warning or error
			if (AnyBlank == true) {
				//Send to Q, send blank card and printer like in 10.13-
				if (AllowBlank == true) {
					this.confirmationService.confirm({
						key: "transferconfirm1",
						acceptLabel: "Yes continue with blanks",
						rejectVisible: true,
						rejectLabel: "No",
						message:
							"Some of the ID Card and Printer options were left blank. If you don't select them now you will have to set them on the ID Printing Page. Do you want to continue?",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.CheckCardStock();
						},
						reject: () => {
							return;
						},
					});
				}
				//Skip to Print, ERROR (10.14+)
				else {
					this.errorMessage = "Select Queue Options for printing";
					return;
				}
			}
			//Skip Ahead, options are not blank
			else {
				this.CheckCardStock();
			}
		}
		//Transfer Only, Keep Going
		else {
			this.CheckCardStock();
		}
	}

	CheckCardStock() {
		// Skip?
		if (this.TransferOption != "SkipToPrint") {
			this.FinishTransfer();
		}
		//
		// Check if Card Stocks are Valid
		//
		else {
			this.errorMessage = "Invalid Card Stock";
			// this.errorMessage = "CHECK CARD STOCK NOT IMPLEMENTED";
			return;
			// this.FinishTransfer();
		}
	}

	FinishTransfer() {
		var FinishInfo = {
			TransferOption: this.TransferOption,
			HasStudent: this.HasStudent,
			HasStaff: this.HasStaff,

			//Queue Options
			Student_IDPrinterID: this.Student_IDPrinterID,
			Student_IDCardTemplateID: this.Student_IDCardTemplateID,
			Staff_IDPrinterID: this.Staff_IDPrinterID,
			Staff_IDCardTemplateID: this.Staff_IDCardTemplateID,

			//Printing Options
			Student_SortID: this.Student_SortID,
			Student_AcademyID: this.Student_AcademyID,
			Student_GradeLevelID: this.Student_GradeLevelID,
			Student_HomeroomID: this.Student_HomeroomID,
		};

		this.ref.close(FinishInfo);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////////////////////

	CheckQueue() {
		this.HasStudent = false;
		this.HasStaff = false;

		for (var z = 0; z < this.lstQueue.length; z++) {
			var next = this.lstQueue[z];

			if (next.IsChecked == true && next.PersonID > 0) {
				if (next.IsStudent == true) {
					this.HasStudent = true;
				}
				if (next.IsStudent == false) {
					this.HasStaff = true;
				}
			}

			if (this.HasStudent == true && this.HasStaff == true) {
				return;
			}
		}
	}

	ShowBoth() {
		return this.HasStudent == true && this.HasStaff == true;
	}

	IsLoading() {
		return this.LoadingData == true || this.LoadingFilters || this.CheckingQ == true || this.Processing == true;
	}

	////////////////////////////////////////////////////////////////////////
}
